import { ConnectedProps, connect } from "react-redux";
import { actions as loginActions } from "../../../reducers/login";
import * as yup from "yup";
import { VALIDATION_REGEX } from "utils/constants";
import RestorePassword from "./RestorePassword";
import { RestorePasswordType, RestorePasswordContainerType } from "./types";
import { useLocation, useHistory } from "react-router";
import { AppDispatch, RootState } from "store";
import { RestorePasswordActionsTypes } from "reducers/types/login";
import i18next from "config/i18next";
import { parseQueryParams } from "utils/utils";
import { sessionSelector } from "reducers/session";

const RestorePasswordContainer = (
  props: RestorePasswordContainerType & ConnectorProps
): JSX.Element => {
  const params = useLocation();
  const history = useHistory();
  const { email, verificationCode } = parseQueryParams(params.search);
  const validationSchema: yup.SchemaOf<RestorePasswordType> = yup.object({
    password: yup
      .string()
      .required(i18next.t("validations:required"))
      .matches(VALIDATION_REGEX.regPassword, " ")
      .matches(
        VALIDATION_REGEX.regPasswordSpecialCharacters,
        i18next.t("validations:specialCharacters")
      ),
    confirmPassword: yup
      .string()
      .required(i18next.t("validations:required"))
      .oneOf(
        [yup.ref("password"), null],
        i18next.t("restorePassword:passwordNotMatch")
      ),
  });

  const onSubmit = (password: string) => {
    const onClick = () => history.replace("/login");
    props.postLoginRestore({
      email: typeof email === "string" ? email : "",
      verificationCode:
        typeof verificationCode === "string" ? verificationCode : "",
      password,
      onClick,
    });
  };

  return (
    <RestorePassword
      {...props}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      testId="restore"
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  isFetching: sessionSelector(state).fetching,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  postLoginRestore: (params: RestorePasswordActionsTypes) => {
    dispatch(loginActions.getLoginRestoreRequest(params));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(RestorePasswordContainer);
